// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__6KVg_","l1":"Label_l1__9PyFs","l2":"Label_l2__JZW2T","l3":"Label_l3__qf5Lj","l4":"Label_l4__7Kz9Q","light":"Label_light__da4T3"};